import { appendSellerGifts } from './append_seller_gifts';
import * as XLSX from "xlsx";
import { OrderList, SellerGiftExport } from "../Interface/Order";

// Keep the same columns as the server's procurement-excel export. The detail ID
// links the returned invoice file to an existing order; names are not identifiers.
export const createPurchaseOrderWorkbook = (orders: OrderList[], gifts?: SellerGiftExport) => {
  const rows = orders.flatMap((order) => {
    const source = order as OrderList & { store_name?: string; order_phone?: string; request_memo?: string | null };
    return order.order_details.flatMap((detail) => {
      const cancelled = detail.cancel_cnt ?? 0;
      const remaining = Math.max(0, detail.order_cnt - cancelled);
      if (["주문취소", "환불처리", "사고처리"].includes(detail.order_status) || (cancelled > 0 && remaining === 0)) return [];
      if (!Number.isSafeInteger(detail.detail_seq) || detail.detail_seq <= 0) {
        throw new Error("주문상품고유번호가 없는 주문은 발주서로 다운로드할 수 없습니다.");
      }
      return [{
        판매사: source.store_name ?? "",
        판매사주문번호: order.seq,
        주문번호: order.seq,
        주문상품고유번호: detail.detail_seq,
        주문일: detail.detail_order_dt ?? "",
        상품코드: detail.product_num ?? "",
        상품명: detail.product_name ?? "",
        고객선택옵션: detail.option_name ?? "",
        주문수량: remaining,
        주문자명: order.order_name ?? "",
        주문자연락처: source.order_phone ?? "",
        수령인명: order.addr_recipient ?? "",
        수령인연락처: order.addr_phone ?? "",
        우편번호: order.addr_num ?? "",
        주소: [order.addr_basic, order.addr_detail].filter(Boolean).join(" "),
        "배송시 요청사항": source.request_memo ?? order.order_inquiry ?? "",
        택배사: detail.delivery_company ?? "",
        배송번호: detail.delivery_info ?? "",
        "팬버드 상품번호": detail.product_seq,
      }];
    });
  });
  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "발주서");
  appendSellerGifts(workbook, orders, gifts);
  return workbook;
};

export const downloadPurchaseOrder = (orders: OrderList[], gifts?: SellerGiftExport) => {
  if (!orders.some(order => order.order_details.length > 0)) {
    alert("다운로드할 주문건이 없습니다.");
    return;
  }
  const workbook = createPurchaseOrderWorkbook(orders, gifts);
  if (XLSX.utils.sheet_to_json(workbook.Sheets['발주서']).length === 0) {
    alert("다운로드할 주문건이 없습니다.");
    return;
  }
  const filename = `팬버드_발주서_${new Date()
    .toISOString()
    .slice(0, 10)
    .replaceAll("-", "")}.xlsx`;
  XLSX.writeFile(workbook, filename);
};
